module.exports = __webpack_public_path__ + "media/warranty-claim/house-37b79ce7.svg";